import { getInputClasses } from "@/components/form/input/InputField"

export type ScopeFilterValue = "all" | "event" | "regional"

const OPTIONS: [ScopeFilterValue, string][] = [
  ["all", "Todos"],
  ["event", "Nacionales"],
  ["regional", "Regionales"],
]

const inputCls = getInputClasses({})

/** Alcance segmentado + búsqueda: reemplaza al selector de evento en el lanzador y en el reporte. */
export function AttendanceScopeFilter({
  scope,
  onScopeChange,
  search,
  onSearchChange,
}: {
  scope: ScopeFilterValue
  onScopeChange: (v: ScopeFilterValue) => void
  search: string
  onSearchChange: (v: string) => void
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="grid grid-cols-3 gap-1 rounded-xl bg-gray-100 p-1 sm:inline-grid dark:bg-gray-800" role="group" aria-label="Tipo de evento">
        {OPTIONS.map(([value, label]) => (
          <button
            key={value}
            type="button"
            aria-pressed={scope === value}
            onClick={() => onScopeChange(value)}
            className={`min-h-10 rounded-lg px-4 py-2 text-sm font-medium transition focus:outline-hidden focus:ring-3 focus:ring-brand-500/20 ${
              scope === value ? "bg-white text-gray-900 shadow-theme-xs dark:bg-gray-900 dark:text-white" : "text-gray-500 dark:text-gray-400"
            }`}
          >
            {label}
          </button>
        ))}
      </div>
      <div className="sm:w-72">
        <label htmlFor="attendance-search" className="sr-only">Buscar evento</label>
        <input
          id="attendance-search"
          type="search"
          className={inputCls}
          placeholder="Buscar evento o región..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
    </div>
  )
}
